import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Context } from '../shared/services/context.service';

@Injectable({
  providedIn: 'root'
})
export class OrientationService {

  constructor(
    private http: HttpClient
  ) { }

  getOrientation(file): Observable<Orientation> {
    const formData = new FormData();
    formData.append('file', file, file.name);

    return this.http.post<Orientation>(`${Context.apiUrl}api/orientation/predict`, formData);
  }

  async rotateImage(file: File, rotation: number): Promise<File> {
    return new Promise<File>((resolve, reject) => {
      const img = new Image();
      const url = URL.createObjectURL(file);
  
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d')!;
  
        // Swap width and height for 90° / 270°
        if (rotation % 180 !== 0) {
          canvas.width = img.height;
          canvas.height = img.width;
        } else {
          canvas.width = img.width;
          canvas.height = img.height;
        }
  
        // Move origin to center and rotate
        ctx.translate(canvas.width / 2, canvas.height / 2);
        ctx.rotate(rotation * Math.PI / 180);
  
        // Draw image centered
        ctx.drawImage(img, -img.width / 2, -img.height / 2);
  
        canvas.toBlob((rotatedBlob) => {
          if (!rotatedBlob) return reject('Rotation failed');
  
          const rotatedFile = new File([rotatedBlob], file.name, {
            type: file.type,
            lastModified: Date.now()
          });
  
          resolve(rotatedFile);
          URL.revokeObjectURL(url);
        }, file.type);
      };
  
      img.onerror = reject;
      img.src = url;
    });
  }

}

export interface Orientation {
  predicted_angle: number;
  confidence: number;
  predictions: { [angle: string]: number };
  image_shape: number[];
  message: string;
}